export const T = {
  en_GB: {
    defaultPortfolioType: "Default Portfolio Type",
    defaultPortfolioTypeDesc:
      "The type new portfolios start with. Automatic uses Model Portfolio when allowed, otherwise the first allowed type",
    automatic: "Automatic",
    model: "Model Portfolio",
    custom: "Custom Portfolio",
    dynamic: "Dynamic Portfolio",
  },
  nb_NO: {
    defaultPortfolioType: "Standard porteføljetype",
    defaultPortfolioTypeDesc:
      "Typen nye porteføljer starter med. Automatisk bruker modellportefølje når den er tillatt, ellers den første tillatte typen",
    automatic: "Automatisk",
    model: "Modellportefølje",
    custom: "Tilpasset portefølje",
    dynamic: "Dynamisk portefølje",
  },
} as const;
